/* External dependencies */
import { applyMiddleware, combineReducers, createStore as createReduxStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { combineEpics, createEpicMiddleware } from 'redux-observable';

/* Local dependencies */
import getDevices from '../components/devices/getDevices/redux/reducer';
import { authReducer } from '../components/webapp/redux/authReducer';
import { confirmCodeEpic, signUpEpic, signInEpic, confirmPasswordEpic, forgotPasswordEpic, signOutEpic, getSessionEpic } from '../components/webapp/redux/epics';

const rootEpic = combineEpics(
  signUpEpic,
  confirmCodeEpic,
  signInEpic,
  forgotPasswordEpic,
  confirmPasswordEpic,
  signOutEpic,
  getSessionEpic
);

const rootReducer = combineReducers( {
  auth: authReducer,
  getDevices,
} );

let store;

export function createStore(): Store {
  const epicMiddleware = createEpicMiddleware();
  store = createReduxStore( rootReducer, composeWithDevTools( applyMiddleware( epicMiddleware ) ) );

  epicMiddleware.run( rootEpic );

  return store;
}

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;